import styled from 'styled-components'

export const DetailLinkListComponent = styled.div`
    background: ${ (props) =>
      props.isAsvList ? props.theme.colors['hintergrund-prio2'] : 'inherit' };
    
    .copy {
    	margin-bottom: 30px;
    }
    
    .link-container {
       margin-bottom: ${ (props) => (props.isAsvList ? '0px' : '30px') };
    }
    
    .label-container {
    	display: flex;
    	flex-direction: ${ (props) => (props.isAsvList ? 'row' : 'column') };
    	align-items: ${ (props) => (props.isAsvList ? 'center' : 'flex-start') };
    	flex-grow: 1;
    	padding-right: 15px;
    	
        @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
          flex-direction: column;
          align-items: flex-start;
        }
	}
	
	&.isAsvList {
		.label {
			display: none;
		}
	}
    
    .link {
    	padding: 20px 30px 24px;
    	display: flex;
    	align-items: center;

        // new styles (replace later)
    	// background-color: ${ (props) =>
        props.isAsvList
          ? 'inherit'
          : props.theme.colors['hintergrund-allgemein'] };
		// width: 100%;
		// color: ${ (props) => props.theme.colors['standard-schwarz'] };
		// box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
		// margin-bottom: 10px;


    	-webkit-print-color-adjust: exact;
    	color-adjust: exact;
    	background-color: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    	width: 100%;
    	color: ${ (props) => props.theme.colors['standard-schwarz'] };
    	box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
    	margin-bottom: 10px;
    	

    	&:hover {
    		text-decoration: none;
    		color: ${ (props) => props.theme.colors['standard-schwarz'] };
    	}

	}
	
	&.isAsvList {
		.link {
			box-shadow: none;
			margin-bottom: 0;
			border-top: 1px solid ${ (props) =>
        props.theme.colors['divider-detail-link-list'] };
			&:last-child {
				border-bottom: 1px solid ${ (props) =>
          props.theme.colors['hintergrund-allgemein'] };
			}
		}
	}

    	
    	@media print {
    		border: 1px solid ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    		width: 100%;
    	}
    }

    
    .name {
    	font-size: 22px;
    	line-height: 27px;
    	color: ${ (props) =>
        props.isAsvList ? props.theme.colors['aok-gruen'] : 'inherit' };
    	
    	@media ${ (props) => props.theme.breakpoints.devices.min.md } {
    		font-size: 24px;
    		line-height: 32px;
    	}
    }
    
    .leader {
      font-size: 20px;
      margin-left: 10px;
        @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
          margin: 5px 0;
        }
    }
    
    .icon-f-arrow-right-circle {
    	font-size: 32px;
		color: ${ (props) => props.theme.colors['aok-gruen'] };
    }
    
    .icon-f-arrow-down {
    	font-size: 14px;
    	margin-left: 12px;
    	transition: .2s;
    	transform: rotate(${ (props) => (props.allVisible ? '180deg' : '0deg') });
    	display: inline-block;
    }
    
    .toggle {
    	margin-bottom: 30px;
    }
`
